import { useRef, useState } from "react";
import { Loading, Modal, ValidationProvider } from "@etframework/ui.components";
import useModalEvent from "../../hooks/useModalEvent";
import ReactDOM from "react-dom";
import { FieldGroupUpdateContainer } from "../../components/CustomFieldGroupComponents/FieldGroupUpdateContainer";
import { FieldGroupCreateContainer } from "../../components/CustomFieldGroupComponents/FieldGroupCreateContainer";
import { useCustomFieldGroup } from "../../data/queries/customFieldGroupQueries";
import { useTranslation } from "react-i18next";

export const CustomFieldGroupModal = () => {
  return (
    <ValidationProvider>
      <InnerCustomFieldGroupModal />
    </ValidationProvider>
  );
};

const InnerCustomFieldGroupModal = () => {
  const { t } = useTranslation(["CustomFieldGroup"]);

  const fieldGroupCreateModalRef = useRef();

  const [customFieldGroupId, setCustomFieldGroupId] = useState(null);

  //Queries
  const { data: customFieldGroup, isPending } =
    useCustomFieldGroup(customFieldGroupId);

  //Modal
  const modalRef = useRef();
  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const [showModal, setShowModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const onModelBeforeClose = () => {};

  const closeModal = () => {
    fieldGroupCreateModalRef?.current?.clearValidationErrors();
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const toggleModal = (e) => {
    const groupId = e.detail?.groupId ?? null;
    const isUpdate = e.detail?.isUpdate ?? false;

    setCustomFieldGroupId(groupId);
    setIsUpdate(isUpdate);
    openModal();
    if (showModal) {
      closeModal();
    } else {
      openModal();
    }
  };

  useRegisterEvent(ModalEvents.CustomFieldGroupModal, toggleModal);

  const onOpen = () => {};

  const ModalContent = () => {
    return (
      <div className="et-custom-fields-modal">
        {isUpdate ? (
          <div>
            {isPending ? (
              <Loading text={t("Loading")} />
            ) : (
              <FieldGroupUpdateContainer
                customFieldGroup={customFieldGroup}
                modalRef={modalRef}
                setCustomFieldGroupId={setCustomFieldGroupId}
                setIsUpdate={setIsUpdate}
              />
            )}
          </div>
        ) : (
          <FieldGroupCreateContainer
            ref={fieldGroupCreateModalRef}
            fieldGroup={customFieldGroup}
            modalRef={modalRef}
            setCustomFieldGroupId={setCustomFieldGroupId}
            setIsUpdate={setIsUpdate}
          />
        )}
      </div>
    );
  };

  useRegisterEvent(ModalEvents.CustomFieldGroupModal, toggleModal);

  return ReactDOM.createPortal(
    <Modal
      id={ModalEvents.CustomFieldGroupModal.Id}
      ref={modalRef}
      isModal
      showCloseIcon={true}
      visible={showModal}
      content={<ModalContent />}
      close={closeModal}
      beforeClose={onModelBeforeClose}
      open={onOpen}
      height="844px"
      width="1140px"
    ></Modal>,
    document.body
  );
};
